import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers/reducers';
import { initData } from './reducers/data';
import App from './components/App/App';
import './index.css';

// the id of the div to render too
const appId = 'fibb';

// default app params
initData.weights = [50,50];

// render
ReactDOM.render(
  <Provider
    store={createStore(
      reducers,
      { data: initData },
      applyMiddleware(thunk),
    )}
  >
    <App />
  </Provider>,
  document.getElementById(appId),
);
